import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/illustration.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Form/ResetPasswordForm.tsx");
